import { Component, OnInit } from '@angular/core';
import { DataService } from "../../services/data.service";
import { AreaService } from 'src/app/services/Area/area.service';

@Component({
  selector: 'app-select-city',
  templateUrl: './select-city.page.html',
  styleUrls: ['./select-city.page.scss'],
})
export class SelectCityPage implements OnInit {
  public searchTerm: string = "";
  public items: any;
   scrollY: any = 0;
   oldScrollY: any = 0;
    private areaService:AreaService
    constructor(private dataService: DataService,) {}

  ngOnInit() {
    this.setFilteredItems();
  }



  setFilteredItems() {
    this.items = this.dataService.filterItems(this.searchTerm);
  }
  logScrolling(event){
      //  console.log("scroll event",event);
      this.oldScrollY = this.scrollY;
       this.scrollY = event.detail.currentY;
     }
     ionViewDidEnter() {
      this.areaService.showHome=false  
    }
}


